export default __webpack_public_path__ + "static/media/logo-dark-theme.981862f9.svg";